<template>
    <form class="w-100" @submit.prevent="buscarAbono">
        <div class="form-group">
            <label for="id_persona">{{ $t('formularios.id') }}</label>
            <input type="number" name="id_persona" v-model="data.id_persona">
        </div>
        <div class="form-group">
            <label for="pin">PIN</label>
            <input type="text" name="pin" v-model="data.pin">
            <span class="error" v-if="error">{{ error.response.errorCodeMsg }}</span>
        </div>

        <div class="row">
            <div class="col-12 d-flex justify-content-between">
                <button type="submit" class="button" name="button" :disabled="loading">Enviar</button>
            </div>
        </div>
    </form>
</template>

<script>
export default {
    props: ['error', 'loading', 'data'],
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
    },
    methods: {
        buscarAbono() {
            this.$emit('buscarAbonado', this.data);
        }
    }
}
</script>